import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'meu-app-home-page-number',
  templateUrl: './app-home-page-number.component.html',
  styleUrls: ['./app-home-page-number.component.scss']
})
export class AppHomePageNumberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
